import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Rx';

import { AppStateService } from '../../services/app-state.service';
import { AlertService } from '../../services/alert.service';
import { SocketService } from '../../services/socket.service';
import { MessageNotificationSocketService } from '../../services/message-notification-socket.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notification-header',
    templateUrl: './notification-header.component.html'
})

export class NotificationHeaderComponent implements OnInit, OnDestroy {
    @Input() modelName: string;
    @Input() modelId: string;
    errorMessage: any;
    accessType: any;

    private subscription1: Subscription;
    private subscription2: Subscription;
    private generalNotificationLists: Array<any> = [];
    private messageNotificationLists: Array<any> = [];
    public notificationLists: Array<any> = [];

    constructor(
        private _alertService: AlertService,
        private _appStateService: AppStateService,
        private _socketService: SocketService,
        private _messageNotificationSocketService: MessageNotificationSocketService,
        private _router: Router
    ) { }

    ngOnInit() {
        // this.setHeaderNotification();
        this.setMessageHeaderNotification();
        this.accessType = this._appStateService.getAccessType();
        console.log('access type..', this.accessType);
    }

    ngOnDestroy() {
        if (this.subscription1) {
            this.subscription1.unsubscribe();
        }
        if (this.subscription2) {
            this.subscription2.unsubscribe();
        }
    }

    setHeaderNotification() {
        this._appStateService.getAppState().take(1).subscribe(appState => {
            if (appState && appState['user']) {
                this._socketService.setHeaderNotifications();
                this.subscription1 = this._socketService.getHeaderNotifications().subscribe(userNotification => {
                    this.generalNotificationLists = userNotification;
                    this._socketService.getMarkRead().subscribe(data => {
                        if(data && data.id) {
                            this.generalNotificationLists.forEach(item => {
                                if(data.id === item.id) {
                                    item['marked_read'] = true;
                                }
                            })
                        } else {
                            this.generalNotificationLists.forEach(item => {
                                item['marked_read'] = true;
                            });
                        }
                        this.mergeNotificationLists();
                    });
                    this.mergeNotificationLists();
                }, error => {
                    this._alertService.error(error);
                });
            }
        })
    }

    /**
     * Merges the job-message-console notifications alongside the general notification list so
     * the header dropdown renders both from the single notificationLists array/template.
     */
    setMessageHeaderNotification() {
        this.subscription2 = this._messageNotificationSocketService.getMessageHeaderNotificationList().subscribe(messageNotification => {
            this.messageNotificationLists = messageNotification;
            this.mergeNotificationLists();
        });
    }

    private mergeNotificationLists() {
        this.notificationLists = [...this.messageNotificationLists, ...this.generalNotificationLists];
        this.errorMessage = (this.notificationLists.length === 0) ? 'No new notification' : '';
    }

    markAsRead(id = null, source = null) {
        if (id) {
            if (source === 'message') {
                this._messageNotificationSocketService.readMessageNotification(id);
            } else {
                //this._socketService.readNotification(id);
            }
            return;
        }
        //this._socketService.readAllNotification();
        this._messageNotificationSocketService.readAllMessageNotification();
    }
    openMessage(row: any): void {
        this._messageNotificationSocketService.readMessageNotification(row.id);        
        const isPO = row.subModelName === 'poMessage';
        this._messageNotificationSocketService.setPendingSelection({
            ...row,
            targetTab: isPO ? 'poMessageTab' : 'caseMessageTab'
        });
        const targetUrl = this.accessType === 'vendor'
            ? '/vms/job-message-console/team/purchase-order'
            : '/vms/job-message-console/team/billing?id=' + row.id;
        if (!this._router.url.startsWith(targetUrl)) {
            this._router.navigate([targetUrl]);
        }
    }
}
